import {Navigate} from 'react-router-dom';
import routes from '../../../components/routes/routes';
import {Box} from './Box';
import {useOrganizerStore} from '../../../common/stores/useOrganizerStore';

type GuardProps = {
  children?: React.ReactNode;
};

export const OrganizerGuard = ({children}: GuardProps) => {
  const organizer = useOrganizerStore(state => state.organizer);
  if (!organizer) {
    return <Navigate to={routes.signIn} replace />;
  }

  return <Box>{children}</Box>;
};
